import "./EachSellerPage";
export const EachSellerPage = () => {
  return(
    <div>
      This is the sellers page
    </div>
  )
}